<template>
    <div>
        <hts-data-table
            ref="dataTables"
            :headers="headers"
            :server="apiList"
            use-selection
            :use-archive="useDriverArchive"
            :use-restore="useDriverRestore"
            store-name="orderDataTable"
            store-key="Order" />

        <Movement ref="movement" />
    </div>
</template>

<script setup lang="ts">
import Movement from './ignore/movement.vue'
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'

import Actions from '~/pages/trucker-[id]/driver/ignore/actions.vue'

const useDriverArchive = { api: $url.order.order.archive, permissions: checkPermission(layoutPermissions.order_archive) }
const useDriverRestore = { api: $url.order.order.restore, permissions: checkPermission(layoutPermissions.order_restore) }

const { $formatters } = useNuxtApp()

const movement = ref()

const apiList = {
  method: 'post',
  url: '/location/list'
}

const dataTables = ref()

const handleViewMovement = (item: any) => {
  if (movement.value) {
    movement.value.open(item)
  }
}

const headers = ref([
  {
    field: 'fullName',
    headerName: $t('labels.fullName'),
    sortable: true
  },
  {
    field: 'contactEmail',
    headerName: $t('labels.contactEmail'),
    sortable: true
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.createdAt)
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.updatedAt'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: Actions,
    cellRendererParams: {
      storeKey: 'orderDataTable',
      storeName: 'Order',
      items: [
        {
          icon: 'hi-eye-icon',
          label: $t('labels.viewMovement'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: true,
          isAll: true,
          click: handleViewMovement
        }
      ]
    }
  }
])
</script>
